import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { browserHistory } from 'react-router';

export function usePageRedirect(path, data) {
  useEffect(() => {
    const needRedirect = data.some(item => isEmpty(item));
    if (needRedirect) browserHistory.push(path);
  }, data);
}



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/utils/usePageRedirect.jsx